import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=d5ad9248&scoped=true"
import script from "./StandardButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StandardButton.vue?vue&type=style&index=0&id=d5ad9248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ad9248",
  null
  
)

export default component.exports